import { render, staticRenderFns } from "./createKp.vue?vue&type=template&id=a3bc14ee&"
import script from "./createKp.vue?vue&type=script&lang=js&"
export * from "./createKp.vue?vue&type=script&lang=js&"
import style0 from "./createKp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports